import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Onboarding from './pages/Onboarding';
import PaymentSuccess from './pages/PaymentSuccess';
import AccessRequest from './pages/AccessRequest';
import Dashboard from './pages/Dashboard';
import Chat from './pages/Chat';
import Decisions from './pages/Decisions';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import Business from './pages/Business';
import DrivingMode from './pages/DrivingMode';
import MondayCompass from './pages/MondayCompass';
import FridayDebrief from './pages/FridayDebrief';
import WeeklyJournal from './pages/WeeklyJournal';
import CaptureJournal from './pages/CaptureJournal';
import Engagements from './pages/Engagements';
import EngagementActive from './pages/EngagementActive';
import Studio from './pages/Studio';
import CFO from './pages/CFO';
import Team from './pages/Team';
import Pointage from './pages/Pointage';

// Components
import MainLayout from './components/MainLayout';
import AccessGuard from './components/AccessGuard';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/access-request" element={<AccessRequest />} />

          {/* Protected Routes — require active status */}
          <Route element={<AccessGuard><MainLayout /></AccessGuard>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/decisions" element={<Decisions />} />
            <Route path="/business" element={<Business />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/journal" element={<WeeklyJournal />} />
            <Route path="/captures" element={<CaptureJournal />} />
            <Route path="/engagements" element={<Engagements />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/cfo" element={<CFO />} />
            <Route path="/team" element={<Team />} />
          </Route>

          {/* Pointage ouvrier — accès public via code équipe + PIN */}
          <Route path="/pointage/:shortcode" element={<Pointage />} />

          {/* Driving Mode — full screen, no layout */}
          <Route path="/driving" element={<AccessGuard><DrivingMode /></AccessGuard>} />

          {/* Monday Compass — full screen, no layout */}
          <Route path="/boussole" element={<AccessGuard><MondayCompass /></AccessGuard>} />

          {/* Friday Debrief — full screen, no layout */}
          <Route path="/debrief" element={<AccessGuard><FridayDebrief /></AccessGuard>} />

          {/* Engagement en cours — full screen, no layout (opened from push notification) */}
          <Route path="/engagements/:id" element={<AccessGuard><EngagementActive /></AccessGuard>} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
